<h3 class="learner-status">
  <span translate>session-review-attendance.component.title</span>

  <span
    translate
    [ngClass]="{
      'is-success': attendanceVerificationStatus == 'passed',
      'is-failure': attendanceVerificationStatus == 'failed',
      'is-pending': attendanceVerificationStatus == 'pending'
    }"
    >session-review.component.verified.{{ attendanceVerificationStatus }}
  </span>
</h3>

@if (anythingEnabled) {
  <table class="attendance-table control table is-bordered is-narrow">
    <thead>
      <tr>
        @if (minimumTimeEnabled) {
          <td translate>session-review-attendance.component.time</td>
        }
        @if (maximumAbsentEnabled) {
          <td translate>session-review-attendance.component.absence</td>
        }
        @if (maximumAssistanceEnabled) {
          <td translate>session-review-attendance.component.assistance</td>
        }
      </tr>
    </thead>
    <tbody>
      <tr>
        @if (minimumTimeEnabled) {
          <td
            translate
            [translateParams]="{ actual: sessionDurationSum, expected: minimumTime }"
            [ngClass]="{ 'is-failure': sessionDurationSum < minimumTime }"
          >
            session-review-attendance.component.time-usage
          </td>
        }
        @if (maximumAbsentEnabled) {
          <td
            translate
            [translateParams]="{ actual: absenceCount, expected: maximumAbsent }"
            [ngClass]="{ 'is-failure': absenceCount > maximumAbsent }"
          >
            session-review-attendance.component.usage
          </td>
        }
        @if (maximumAssistanceEnabled) {
          <td
            translate
            [translateParams]="{ actual: assistanceCount, expected: maximumAssistance }"
            [ngClass]="{ 'is-failure': assistanceCount > maximumAssistance }"
          >
            session-review-attendance.component.usage
          </td>
        }
      </tr>
    </tbody>
  </table>
}
